// tslint:disable: completed-docs
import {connect, injectReducer, injectSaga} from '@vfde-sails/core';
import {RootState} from './types';
import {createStructuredSelector} from 'reselect';
import {TRACKING_STORE} from './constant';
import trackingSaga from 'Container/Tracking/saga';
import trackingReducer from 'Container/Tracking/reducer';
import {
    offerGetsVisible,
} from 'Container/Landingpage/action';
import { handleScrollEvent } from 'Container/OfferDisplay/helpers/eventHelper';

interface StateProps {
}

/**
 * Landingpage function
 */
function Tracking (state, action) {

    injectReducer(TRACKING_STORE, trackingReducer);
    injectSaga(TRACKING_STORE, trackingSaga);

    /**
     * attach action to window scroll event. action is defined in landing page
     * as all actions and states belonging to the page itself are capsulate there
     */
    handleScrollEvent(action.offerGetsVisible);

    return {

        /**
         * This function is called on first load and everytime the store changes.
         * @param newState
         * @param oldState - You may also pass the oldState here, if needed
         */
        getDerivedStateFromProps (newState) {
        },
    };
}

const mapStateToProps = createStructuredSelector<RootState, StateProps>({
});

const mapDispatch = {
    offerGetsVisible,
};

const tracking = connect(mapStateToProps, mapDispatch)(Tracking);
export default tracking;
